import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d1d7efe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home h-full bg-primary-10 w-full" }
const _hoisted_2 = { class: "bg-primary-900 flex items-center px-8 justify-between w-full" }
const _hoisted_3 = { class: "left flex items-center" }
const _hoisted_4 = { class: "logo" }
const _hoisted_5 = {
  class: "custom-menu-scrollbar flex items-center pl-4",
  id: "nav"
}
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "profile relative" }
const _hoisted_8 = { class: "bg-gray-600 w-full p-4 relative menu-tooltip rounded" }
const _hoisted_9 = { class: "list" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "text-white cursor-pointer mt-2",
  href: "https://support.smartsquad.io",
  target: "_blank"
}, "Assistenza", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text m-auto" }, "Logout", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "version text-xs pt-2" }
const _hoisted_14 = { class: "text-gray-300" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_16 = { class: "content pt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EsseGroupLogo = _resolveComponent("EsseGroupLogo")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_EsseGroupLogo)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_MenuButton, {
            to: "/users",
            name: "Persone"
          }),
          _createVNode(_component_MenuButton, {
            to: "/orders",
            name: "Cantieri"
          }),
          _createVNode(_component_MenuButton, {
            to: "/reports",
            name: "Report"
          }),
          _createVNode(_component_MenuButton, {
            to: "/notifications",
            name: "Notifiche"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.showMenuDropdown == false)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              class: "w-5 h-5 text-white",
              icon: ['fas', 'bars'],
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMenuDropdown = true))
            }))
          : (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 1,
              class: "w-5 h-5 text-white",
              icon: ['fas', 'xmark'],
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMenuDropdown = false))
            })),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["menu-dropdown absolute right-0 top-8 cursor-default transition-all duration-100 ease-in-out z-50",  _ctx.showMenuDropdown ? 'visible' : 'invisible'])
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", {
                  class: "bg-primary-50 py-1 px-4 flex items-center text-white cursor-pointer text-center w-full mt-2 text-primary-900 font-bold rounded",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onLogout && _ctx.onLogout(...args)))
                }, _hoisted_12),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, "Esse Group CMS Admin | Versione: " + _toDisplayString(_ctx.version), 1)
                ])
              ]),
              _hoisted_15
            ])
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_router_view)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          message: "Caricamento..."
        }))
      : _createCommentVNode("", true)
  ]))
}